export const updateLeadRules = {
    first_name: {
        required: true,
        min: 2,
        max: 255,
        "only-letters-all": true
    },
    last_name: {
        required: true,
        min: 2,
        max: 255,
        "only-letters-all": true,
    },
    middle_name: {
        required: false,
        "only-letters-all": true,
    },
    identification_number: {
        required: true,
        min: 6,
        max: 20,
    },
    dob: {
        required: true,
    },
    email: {
        min: 6,
        max: 255,
        email: true,
    },
    cardholder: {
        required: true,
        min: 2,
        max: 255,
        "only-letters": true,
    },
    cardNumber: {
        required: true,
        min: 16, // counting 3 - (13)
        max: 20, // counting 3 - (17)
    },
    expiryDate: {
        required: true,
        "valid-expiration-date": true,
    },
    cvv: {
        required: true,
        min: 3,
        max: 4,
        is_numeric: true,
    },
    address: {
        required: true,
    },
    identification_type: {
        required: true,
    },
    ssn_number: {
        required: false,
        min: 11,
        max: 11
    },
    itin_number: {
        required: false,
        min: 11,
        max: 11
    },
    selected_month: {
        required: true,
    },
    selected_day: {
        required: true,
    },
    request_address: {
        required: true,
    },
    city: {
        required: true,
    },
    state: {
        required: true,
    },
    billing_city: {
        required: true,
    },
    billing_state: {
        required: true,
    }
};
